// extracted by mini-css-extract-plugin
export default {"Map":"styles_Map__wdRyc","MapWrap":"styles_MapWrap__6a91y"};